<template lang="html">
  <div class="dashboard">
    <v-header :name="name" :isDashboard="!child" :onBack="true" @backClick="backToDashboard"></v-header>
    <!-- <v-header :name="name" isDashboard></v-header> -->
    <div class="container">
      <div class="left">
        <div class="item">
          <v-pie></v-pie>
        </div>
        <div class="item">
          <v-table></v-table>
        </div>
        <div class="item">
          <v-bars></v-bars>
        </div>
        <div class="item">
          <v-iot></v-iot>
        </div>
      </div>
      <div class="center">
        <v-center :child="child" @clickChild="clickChild"></v-center>
      </div>
      <div class="right">
        <div class="item">
          <v-bar></v-bar>
        </div>
        <div class="item">
          <v-flow></v-flow>
        </div>
        <div class="item">
          <v-circle-bar></v-circle-bar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import header from 'components/common/header'
import pie from 'components/dashboard/pie'
import table from 'components/dashboard/table'
import circle from 'components/dashboard/circle'
import iot from 'components/dashboard/iot'
import bar from 'components/dashboard/bar'
import bars from 'components/dashboard/bars'
import circleBar from 'components/dashboard/circleBar'
import circleB from 'components/dashboard/circleB'
import flow from 'components/dashboard/flow'
import center from 'components/dashboard/center'
import particles from 'particles.js'
// import Stats from '../../../static/js/particles'
// import '../../../static/js/app'
// import '../../../static/js/lib/stats'
export default {
  data() {
    return {
      items: [],
      countParticles: '',
      stats: '',
      update: '',
      name: '百色市农业大脑',
      child: false
    }
  },
  mounted() {
    particlesJS.load('particles', '../../../static/data/don.json');
  },
  methods: {
    clickChild(bool) {
      this.child = bool;
    },
    backToDashboard() {
      this.child = false;
    }
  },
  components: {
    'v-header': header,
    'v-table': table,
    'v-circle': circle,
    'v-pie': pie,
    'v-iot': iot,
    'v-bar': bar,
    'v-bars': bars,
    'v-flow': flow,
    'v-circle-bar': circleBar,
    'v-circ': circleB,
    'v-center': center
  }
}

</script>

<style lang="stylus" scoped>
html,body{ width: 100%; height: 100%; background-color: #060606; }
.item
    margin-bottom 15px
.dashboard
  position relative
  width 100%
  height 100%
  margin 0
  padding 0
  background-size 100% 100%
.container
    display flex
    height 100%
    padding 0 15px
    .center
      width 896px
      margin 30px auto
    .left, .right
       width 450px
       margin-top -25px
</style>



// WEBPACK FOOTER //
// index.vue?50ede7f7